// @ts-nocheck
import ga from "@store/Framework/Common/GoogleAnalytics";
import { TrackCancelQuickOrderListUploadParameters } from "@store/Framework/Common/GoogleAnalytics/trackers/quickOrder/trackCancelQuickOrderListUpload";

const useTrackCancelQuickOrderListUpload = (
    parameters: TrackCancelQuickOrderListUploadParameters = {},
    options?: Toolkit.GoogleAnalytics.Options,
) => {
    return ga.util.getEventTrackerHook(ga.track.cancelQuickOrderListUpload, parameters, options);
};

export default useTrackCancelQuickOrderListUpload;
